import { WHATSAPP_NUMBER } from "@/lib/i18n";

export function buildWhatsAppLink(message) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function buildBookingMessage({ t, form, quote }) {
  const lines = [t("form.whatsapp_msg_intro"), ""];
  if (form?.pickup_location && form?.dropoff_location) {
    lines.push(`${t("form.whatsapp_msg_route")}: ${form.pickup_location} → ${form.dropoff_location}`);
  }
  if (form?.pickup_date || form?.pickup_time) {
    lines.push(`${t("form.whatsapp_msg_date")}: ${form?.pickup_date || ""} ${form?.pickup_time || ""}`.trim());
  }
  if (form?.passengers) lines.push(`${t("form.whatsapp_msg_pax")}: ${form.passengers}`);
  if (form?.vehicle_type) lines.push(`${t("form.whatsapp_msg_vehicle")}: ${form.vehicle_type}`);
  if (quote?.total_price_eur) {
    lines.push(`${t("form.whatsapp_msg_estimate")}: ~€${Math.round(quote.total_price_eur)} (${quote.distance_km} km)`);
  }
  return lines.filter(Boolean).join("\n");
}
